import { useContext, createContext } from 'react'
import { initialState } from '../reducer/relocateReducer'
import { actionTypes } from '../types/actionTypes'
import { ReducerRelocateState } from '../types/reducerTypes'

interface RelocateContext {
  state: ReducerRelocateState
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
export const RelocateContext = createContext<RelocateContext>({
  state: initialState,
  dispatch: () => {}
})

// Se crea un custom hook para validar que nuestro contexto no contenta una instancia indefinida
// y una vez se valide que si contiene una instancia, lo retornamos para su uso posterior

export const useRelocate = () => {
  const context = useContext(RelocateContext)
  if (context === undefined) {
    throw new Error('useRelocate must be used within a Provider')
  }

  return context
}
